import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_MEMBERSHIP_ANNUAL_CONTRIBUTION = createFcmDetails('membership_annual_contribution', {
	owner: 'Monetization Squad',
	context: 'Membership Join page',
	description: 'This FC controls the visibility of yearly payment term on Membership Join page',
	import: false,
	template: {
		enabled: true,
		amounts: [100, 200, 300, 400],
		minAmount: 100,
		maxAmount: 15000,
	},
});
